import Dash from './Dash';

export default Dash;
